import {EyeIcon, PlusIcon} from '@/components/ui/icon/Icon'
import {Menu, MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {useTranslation} from '@/translations/i18n'
import {useMenuContext} from '@ariakit/react'

interface AgendaAppointmentEventContextMenuProps {
    onChange: (action: 'viewDetails' | 'addEvent') => void
    anchorRect: {x: number; y: number}
}

export const AgendaAppointmentEventContextMenu = ({onChange, anchorRect}: AgendaAppointmentEventContextMenuProps) => {
    const contextMenu = useMenuContext()
    const {t} = useTranslation()

    const handleClick = (action: 'viewDetails' | 'addEvent') => {
        onChange(action)
        contextMenu?.hide()
    }

    return (
        <Menu store={contextMenu} getAnchorRect={() => anchorRect} modal>
            <MenuItem onClick={() => handleClick('viewDetails')}>
                <EyeIcon />
                {t('agenda:show_details')}
            </MenuItem>

            <MenuItem onClick={() => handleClick('addEvent')}>
                <PlusIcon />
                {t('commons:dropdown_add_event')}
            </MenuItem>
        </Menu>
    )
}
